<template>
  <div>
    <el-dialog
      :visible.sync="dialogShow"
      @close="dialogShowClose"
      :show-close="false"
      width="642px"
      custom-class="lenders"
      center>
      <div class="lendersInfo">
        <div class="head">
          <div class="title">放款信息</div>
          <div class="closeBtn" @click="dialogShowClose">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="body">
          <div class="list">
            <div class="item" :class="{'checkItem':item === lendersChecked}" v-for="(item,index) in lendersInfoList"
                 :key="index" @click="lendersInfoItemChange(item)">
              <div id="item">
                <div class="radio">
                  <div></div>
                </div>
                <div class="info">
                  <div class="payment-methods">
                    <i class="iconfont"
                       :class="item.account_type === 1?'pxb7-alipay-icon':item.account_type === 2?'pxb7-wechat-pay-icon':'pxb7-bank-pay-icon'"></i>
                    {{ item.account_type === 1 ? '支付宝' : item.account_type === 2 ? '微信' : '银行卡' }}
                    <span style="margin: 0 0 0 5px">{{item.account_bank_name}}</span>
                  </div>
                  <div class="payment-account">
                    <span>{{ item.account_user_name }}</span>
                    {{ item.account }}
                  </div>
                </div>
                <div class="item-btn-group">
                  <div @click.stop="editLendersClick(item)"><i class="iconfont pxb7-edit-icon"></i></div>
                  <div @click.stop="delLendersClick(item)"><i class="iconfont pxb7-del-icon"></i></div>
                </div>
              </div>
            </div>
          </div>
          <div class="add" @click="addShowClick">
            <i class="el-icon-plus"></i>
            新增信息
          </div>
          <div class="btn-group">
            <div class="btn" @click="dialogShowClose">取消</div>
            <button v-prevent-re-click class="btn confirm" @click="submitLending">确认</button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="delShow"
      :show-close="false"
      width="358px"
      top="25vh"
      custom-class="del"
      center>
      <div class="del-body">
        <div class="title">提示</div>
        <div class="text">
          是否确认删除<br/>
          <span>
            {{ delObj.account_type === 1 ? '支付宝' : delObj.account_type === 2 ? '微信' : '银行卡' }}
            {{ `${delObj.account.slice(0, 3)}***${delObj.account.slice(-3)}` }}
          </span>
          收款信息
        </div>
        <div class="btn-group">
          <div class="btn" @click="canceldelShow()">取消</div>
          <button v-prevent-re-click class="btn confirm" @click="delLendersInfo">确认</button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="addShow"
      :show-close="false"
      width="642px"
      custom-class="lenders"
      center>
      <div class="lendersInfo add-lendersInfo">
        <div class="head">
          <div class="title">新增放款信息</div>
          <div class="closeBtn" @click="addShowClose">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="body">
          <el-form :model="addForm" :rules="rules" ref="addForm" label-width="90px" class="addForm">
            <el-form-item label="收款人" prop="account_user_name">
              <el-input v-model="addForm.account_user_name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="收款方式" prop="account_type">
              <el-select v-model="addForm.account_type" placeholder="请选择收款方式">
                <el-option label="支付宝" :value="1"></el-option>
                <el-option label="微信" :value="2"></el-option>
                <el-option label="银行卡" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收款账号" prop="account">
              <el-input v-model="addForm.account" placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item label="开户行" prop="account_bank_name" v-if="addForm.account_type == 3">
              <el-input v-model="addForm.account_bank_name" placeholder="请输入xxx省xxx市xxx开户行"></el-input>
            </el-form-item>
          </el-form>
          <div class="btn-group">
            <div class="btn" @click="addShowClose">取消</div>
            <button v-prevent-re-click class="btn confirm" @click="submitForm('addForm')">保存</button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  apiUserAccountList,
  apiUserAccountAdd,
  apiUserAccountEdit,
  apiUserAccountDel,
  apiUserAccountLending
} from "@/request/API";

export default {
  name: "lendersInfo",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    game_id: {
      type: Number,
      default: null
    },
    product_id: {
      type: Number,
      default: null
    },
  },
  components: {},
  data() {
    return {
      //收款信息列表
      lendersInfoList: [],
      //选中的收款信息
      lendersChecked: {},
      dialogShow: this.show,
      //要编辑的放款信息
      editObj: {},
      api: apiUserAccountAdd,
      //删除放款信息弹窗
      delShow: false,
      //要删除的放款信息
      delObj: {
        account_type: '',
        account: ''
      },
      //新增放款信息
      addShow: false,
      addForm: {
        account_user_name: '',
        account_type: '',
        account: '',
        account_bank_name: '',
      },
      rules: {
        account_user_name: [
          {required: true, message: '请输入收款人', trigger: 'blur'},
          // { pattern: /^[\u4e00-\u9fa5]{0,}$/, message: '仅限输入中文', trigger: 'blur' }

        ],
        account_type: [
          {required: true, message: '请选择收款方式', trigger: 'change'}
        ],
        account: [
          {required: true, message: '请输入收款账号', trigger: 'blur'},
        ],
        account_bank_name: [
          {required: true, message: '请输入开户行', trigger: 'blur'},
        ],
      }


    }
  },
  methods: {
    /**
     * 获取放款信息
     */
    getLendersInfoList() {
      apiUserAccountList({}).then(res => {
        this.lendersInfoList = res.data
      })
    },
    /**
     * 选中收款信息
     */
    lendersInfoItemChange(item) {
      this.lendersChecked = item
    },
    /**
     * 删除放款信息
     */
    delLendersInfo() {
      apiUserAccountDel({
        id: this.delObj.id
      }).then(res => {
        this.canceldelShow()
      })
    },
    /**
     * 放款信息删除按钮
     */
    delLendersClick(item) {
      this.delObj = item
      this.delShow = true
      this.$emit('lendersInfoShowClose')
    },
    /**
     * 放款信息编辑按钮
     */
    editLendersClick(item) {
      this.editObj = item
      this.api = apiUserAccountEdit
      this.addShowClick()
    },
    /**
     * 删除弹窗取消按钮
     */
    canceldelShow() {
      this.delShow = false
      this.$emit('lendersInfoShowOpen')
    },
    /**
     * 新增放款信息按钮
     */
    addShowClick() {
      this.addShow = true
      this.$emit('lendersInfoShowClose')
    },
    /**
     * 新增放款信息弹窗关闭
     */
    addShowClose() {
      this.$refs['addForm'].resetFields();
      this.addShow = false
      this.api = apiUserAccountAdd
      this.editObj = {}
      this.$emit('lendersInfoShowOpen')
    },
    /**
     * 新增放款信息表单提交
     */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let p = {
            account_user_name: this.addForm.account_user_name,
            account: this.addForm.account,
            account_type: this.addForm.account_type,
            account_bank_name: this.addForm.account_bank_name,
          }
          if (this.editObj) {
            p.id = this.editObj.id
          }
          this.api(p).then(res => {
            this.$message({
              center: true,
              type: 'success',
              message: res.msg
            })
            this.addShowClose()
          }).catch(e=>{
            this.$message({
              center: true,
              type: 'error',
              message: e.msg
            })
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * 申请放款
     */
    submitLending(){
      if (Object.keys(this.lendersChecked).length == 0) {
        this.$message({
          center: true,
          type: 'error',
          message: '请选择收款账号！'
        })
        return
      }
      apiUserAccountLending({
        game_id:this.game_id,
        product_id:this.product_id,
        user_account_id:this.lendersChecked.id,
      }).then(res=>{
        this.$message({
          center: true,
          type: 'success',
          message: '申请放款成功'
        })
        this.dialogShowClose()
      }).catch(e=>{
        this.$message({
          center: true,
          type: 'error',
          message: e.msg
        })
      })
    },
    /**
     * 放款列表关闭
     */
    dialogShowClose(){
      this.lendersChecked = {}
      this.$emit('close')
    }
  },
  watch: {
    show(val) {
      this.dialogShow = val
      if (val) {
        this.getLendersInfoList()
      }
    },
    editObj(val) {
      this.addForm = val
    }
  },
  created() {

  },
  mounted() {
    this.getLendersInfoList()
  }
}
</script>

<style scoped lang="less">

/deep/ .lenders {
  .el-dialog__header, .el-dialog__body {
    padding: 0 !important;
  }

  .el-icon-close {
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 800;
  }
}

/deep/ .del {
  .el-dialog__header, .el-dialog__body {
    padding: 0 !important;
  }

  .el-icon-close {
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 800;
  }
}

.lendersInfo {
  .head {
    height: 66px;
    line-height: 66px;
    text-align: center;
    background: var(--bg-dark, #1A1D24);
    border-radius: 4px 4px 0 0;
    position: relative;

    .title {
      font-size: 22px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }

    .closeBtn {
      font-size: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      position: absolute;
      right: 23px;
      top: 0;
      cursor: pointer;
    }
  }

  .body {
    width: 642px;
    padding: 29px 0 37px;

    .list {
      height: 201px;
      overflow: auto;

      .item {
        height: 65px;
        padding: 0 25px 0 26px;
        display: flex;
        justify-content: center;

        #item {
          cursor: pointer;
          display: flex;
          align-items: center;
          border-bottom: 2px solid #E6E9EF;
          padding: 0 46px 0 45px;

          .radio {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            cursor: pointer;
            border: 2px solid var(--border-strong, #D8D2CA);
          }

          .info {
            margin: 0 20px;

            .payment-methods {
              display: flex;
              align-items: center;
              font-size: 14px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #000000;
              margin: 0 0 5px;

              i {
                margin: 0 5px 0 0;
              }

            }

            .payment-account {
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #777777;
              width: 364px;

              span {
                margin: 0 10px 0 0;
              }
            }
          }

          .item-btn-group {
            display: flex;
            align-items: center;

            div {
              width: 20px;
              height: 20px;

              i {
                font-size: 20px;
                color: #989898;
              }
            }

            div:first-of-type {
              margin: 0 18px 0 0;
            }
          }
        }

        &:hover {
          background: #FFFAF0;

        }
      }

      .checkItem {
        background: #FFFAF0;

        #item {
          .radio {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: none;
            background: var(--primary, #FF5A1F);
            display: flex;
            align-items: center;
            justify-content: center;

            div {
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #FFFFFF;
            }
          }
        }
      }
    }

    .list::-webkit-scrollbar-track {
      border-radius: 4px;
      background: transparent;
    }

    .list::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    .list::-webkit-scrollbar-thumb {
      border-radius: 4px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(0, 0, 0, 0.2);
    }

    .add {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 9px 0 29px;
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #888C90;
      cursor: pointer;
      user-select: none;

      i {
        font-size: 20px;
        margin: 0 4px 0 0;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 1000;
      }
    }

    .btn-group {
      display: flex;
      align-items: center;
      justify-content: center;

      .btn {
        width: 158px;
        height: 36px;
        border: 1.5px solid var(--bg-dark, #1A1D24);
        cursor: pointer;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: var(--text-main, #1A1D24);
        user-select: none;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .confirm {
        background: var(--primary, #FF5A1F);
        border: 1px solid var(--primary, #FF5A1F);
        color: #FFFFFF;
        margin: 0 0 0 15px;
      }
    }
  }

}

.del-body {
  padding: 26px 0 35px;

  .title {
    font-size: 20px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #353535;
    text-align: center;
  }

  .text {
    margin: 21px 0 17px;
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #696969;

    span {
      font-size: 18px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #F0EDE8;
    }
  }

  .btn-group {
    display: flex;
    align-items: center;
    justify-content: center;

    .btn {
      width: 138px;
      height: 38px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1.5px solid var(--bg-dark, #1A1D24);
      cursor: pointer;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #1A1D24);
      user-select: none;
      border-radius: 4px;
    }

    .confirm {
      background: var(--primary, #FF5A1F);
      border: 1px solid var(--primary, #FF5A1F);
      color: #FFFFFF;
      margin: 0 0 0 15px;
    }
  }

}

.add-lendersInfo {
  .body {
    .addForm {
      margin: 0 0 32px 87px;

      /deep/ .el-form-item {
        display: flex;
        align-items: center;
      }

      /deep/ .el-form-item__content {
        margin: 0 0 0 24px !important;
      }

      /deep/ .el-form-item__label {
        padding: 0;
        flex-shrink: 0;
        font-size: 16px !important;
        font-family: PingFang SC-Medium, PingFang SC !important;
        font-weight: 500 !important;
        color: #1A1D24 !important;
        float: none;
      }

      /deep/ .el-input__inner {
        width: 360px;
        height: 45px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);

        &::placeholder {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
        }

        &:focus {
          border: 1px solid var(--primary, #FF5A1F);
          box-shadow: none;
        }
      }
    }
  }
}
</style>
